import React from "react"
import { graphql } from "gatsby"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
import Post from "../components/post"

const NewsPostTemplate = ({ data: { translations, news, latest } }) => {
  return (
    <Layout>
      <Post
        data={news}
        other={latest}
        otherHeading={translations.global.latestNews}
      />
    </Layout>
  )
}

export default NewsPostTemplate

export const Head = ({ data: { news } }) => {
  return (
    <Meta
      data={{
        title: news.title,
        socialImage: news.images[0]?.images.fallback.src,
      }}
    />
  )
}

export const pageQuery = graphql`
  query ($id: String!) {
    translations: translationsJson {
      global {
        latestNews
      }
    }

    news: newsJson(id: { eq: $id }) {
      title
      body
      date: publish_at(formatString: "YYYY-MM-DD")
      files {
        id
        url
        text
      }
      links {
        id
        url
        text
      }
      images {
        ...NKimageFragment
      }
      sites {
        ...SitesCardFragment
      }
    }

    latest: allNewsJson(
      filter: { id: { ne: $id } }
      sort: { publish_at: DESC }
      limit: 3
    ) {
      nodes {
        ...NewsCardFragment
      }
    }
  }
`
